import SectionHead from '@/components/general/SectionHead';
import React from 'react';
// import Filters from './Filters';
import { categoryType, direction, setState } from '@/commonTypes';
import { useTranslations } from 'next-intl';
import styles from '../styles.module.css';
import { useSearchParams } from 'next/navigation';
import useWindowDimensions from '@/functions/useWindowDimensions';
import Button from '@/components/common/Button';
import MainIcons from '@/icons/main';
import { TRIGGERS } from '@/api/global';
import { useLayoutContext } from '@/context/LayoutContext';
import BlogsFiltersSection from '@/components/pages/blog/blogsContent/BlogsFiltersSection';
import Filters from '@/components/general/Filters';
import ViewToggle from '../ViewToggle';

export default function ProductsFilters({
  setPageNumber,
  count,
  direction = 'vertical',
  setDirection,
  path = '/products',
}: {
  setPageNumber: setState<number | string>;
  count?: string | number;
  direction?: direction;
  setDirection?: setState<direction>;
  path?: string;
}) {
  const { setTrigger, activeCategories } = useLayoutContext();
  const searchParams = useSearchParams();
  const tCommon = useTranslations('common');
  const { width } = useWindowDimensions();
  return (
    <SectionHead
      // title={
      //   <span>
      //     {/* {tCommon('allDevices')}{' '} */}
      //     {searchParams?.get('search') && (
      //       <span className={`${styles.searchValue}`}>
      //         {'.' + '“' + searchParams?.get('search') + '”'}
      //       </span>
      //     )}
      //   </span>
      // }
      text={
        <span style={{ fontSize: '14px' }}>
          <span style={{ fontWeight: '600' }}>{count}</span>{' '}
          {path == '/products' ? 'محصول' : 'مرکز خدماتی'} در
          <span className={styles.cat}>
            {activeCategories?.length != 0
              ? activeCategories?.map((x: categoryType) => x?.title)?.join(' , ')
              : 'همه'}
          </span>
        </span>
      }
      buttonChild={
        <div className={`${styles.headFilterButtons}`}>
          <Button
            className={` ${styles.mobile_filter_btn}`}
            onClick={() => {
              setTrigger(TRIGGERS.PRODUCT_FILTERS);
            }}
          >
            <MainIcons.filterIcon />
            <span> فیلتر‌ها</span>
          </Button>
          {/* <Filters
            setPageNumber={setPageNumber}
            sortParams={{
              sort: searchParams?.get('sort'),
              orderBy: searchParams?.get('orderBy'),
            }}
          /> */}
          <Filters
            setPageNumber={setPageNumber}
            sortParams={{
              sort: searchParams?.get('sort'),
              orderBy: searchParams?.get('orderBy'),
            }}
          />
          {path == '/products' && (
            <ViewToggle
              direction={direction}
              setDirection={setDirection}
              className={`${styles.viewToggle}`}
            />
          )}
          {/* <BlogsFiltersSection
                      category={category?.response}
                      // totalCount={category?.response_details?.count}
                      totalCount={21}
                      activeCategory={activeCategory}
                      sortParams={{
                        sort: searchParams?.get('sort'),
                        orderBy: searchParams?.get('orderBy'),
                      }}
                      setPageNumber={setPageNumber}
                      urlQuery={true}
                      activeKey="slug"
                    /> */}
        </div>
      }
      titleClass={`${styles.titleClass}`}
      textTitle={`${styles.textTitle}`}
      wrapper={`${styles.headWrapper} card`}
    />
  );
}
